export default "__VITE_ASSET__CE6z9UPI__"